import type { FC } from 'react';
import React from 'react';
import cn from 'classnames';
import { MagnifierMIcon } from '@alfalab/icons-glyph/MagnifierMIcon';

import type { TSearchIcon } from './models';

export const SearchIcon: FC<TSearchIcon> = ({ onClick, styles }) => {
    return (
        <div className={cn(styles.searchIconWrapper)}>
            <MagnifierMIcon cursor="pointer" onClick={onClick} />
        </div>
    );
};
